/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Return_Decision_NoteInputs */

const vi_carrier_return_decision_note = /** @type {(inputs: Carrier_Return_Decision_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú gửi hãng vận chuyển`)
};

/**

* @param {Carrier_Return_Decision_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_return_decision_note = /** @type {((inputs?: Carrier_Return_Decision_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Return_Decision_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_return_decision_note(inputs)
});